import Welcome from ".";
const WelcomeRoutes = {
  routes: [
    {
      path: "/",
      component: Welcome,
      exact: true,
    },
  ],
};
export default WelcomeRoutes;
